export const congrats = {
  style: {
    images: `./img/congrats/1-son.png`,
    text: `В День защитника пусть все сложится и все радости сразу умножатся!`,
  },
  sport: {
    images: `./img/congrats/2-dad.png`,
    text: `Папочка, люблю тебя. С 23 Февраля!`,
  },
  brave: {
    images: `./img/congrats/3-brother.png`,
    text: `С праздником, любимый брат. Будь здоров ты и богат!`,
  },
  econom: {
    images: `./img/congrats/4-husband.png`,
    text: `Настоящему мужчине прошепчу: «Люблю тебя!» Будь счастливым, смелым, сильным!`,
  },
  beauty: {
    images: `./img/congrats/5-favorite.png`,
    text: `Любимый мой, хочу тебя поздравить и нежный поцелуй добавить!`,
  },
  roman: {
    images: `./img/congrats/6-friend.png`,
    text: `Побольше оптимизма всем защитникам Отчизны!`,
  },
};
